interface YoYBadgetProps {
  atual: number;
  anterior: number;
  label: string;
  isCurrency?: boolean;
}

function calcVariacao(atual: number, anterior: number): number {
  if (anterior === 0) return atual > 0 ? 100 : 0;
  return ((atual - anterior) / anterior) * 100;
}

export default function YoYBadget({ atual, anterior, label, isCurrency = false }: YoYBadgetProps) {
  const variacao = calcVariacao(atual, anterior);
  const isPositive = variacao >= 0;
  const format = (val: number) =>
    isCurrency
      ? val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      : val.toLocaleString('pt-BR');

  return (
    <div className="bg-white rounded-xl p-4 border border-gray-100">
      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">{label}</p>
      <div className="flex items-baseline space-x-2 mt-1">
        <p className="text-xl font-bold text-gray-800">{format(atual)}</p>
        <div className={`flex items-center space-x-0.5 px-1.5 py-0.5 rounded text-[10px] font-bold ${isPositive ? 'bg-emerald-50 text-emerald-600' : 'bg-red-50 text-red-600'}`}>
          {isPositive ? (
            <i className="ri-arrow-up-line"></i>
          ) : (
            <i className="ri-arrow-down-line"></i>
          )}
          <span>{Math.abs(variacao).toFixed(1)}%</span>
        </div>
      </div>
      <p className="text-[10px] text-gray-400 mt-1">
        vs {format(anterior)} ano anterior
      </p>
    </div>
  );
}